import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Banknote, Bell, Folder, Gift, Trophy, User, UserPlus, Wallet } from "lucide-react";

import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Header } from "@/components/header";
import { Empty, ErrorView, Loading } from "@/components/kit";
import { dateTime } from "@/lib/format";

const ICONS = { account: User, dossier: Folder, commission: Wallet, payment: Banknote, referral: Gift, ranking: Trophy, agent: UserPlus, info: Bell };

export default function Notifications() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { user } = useAuth();
  const q = useQuery({ queryKey: ["notifications"], queryFn: () => api("/notifications") });
  useEffect(() => {
    if (q.data?.unread) {
      api("/notifications/read-all", { method: "POST" }).then(() => {
        qc.invalidateQueries({ queryKey: ["agent-dashboard"] });
        qc.invalidateQueries({ queryKey: ["admin-dashboard"] });
      });
    }
  }, [q.data?.unread, qc]);
  const isAdmin = user && user.role === "admin";
  return (
    <div data-testid="notifications-screen" className="flex flex-col">
      <Header title="Notifications" />
      {q.isLoading ? <Loading /> : q.isError ? <ErrorView message="Erreur de chargement." onRetry={() => q.refetch()} /> : (
        <ul className="mx-auto flex w-full max-w-3xl flex-col gap-2 p-4 pb-8 md:p-8">
          {!q.data?.items?.length && <Empty icon={Bell} title="Aucune notification" />}
          {q.data?.items?.map((item) => {
            const Icon = ICONS[item.kind] ?? Bell;
            return (
              <li key={item.id}>
                <button
                  type="button"
                  data-testid={`notification-${item.id}`}
                  disabled={!item.dossier_id}
                  onClick={() => item.dossier_id && navigate(isAdmin ? `/admin/dossier/${item.dossier_id}` : `/dossier/${item.dossier_id}`)}
                  className={`focus-ring flex w-full gap-3 rounded-xl border p-3 text-left transition-colors enabled:hover:border-[#D4AF37] disabled:cursor-default ${item.read ? "border-[#333333] bg-[#1E1E1E]" : "border-[#D4AF37] bg-[#292415]"}`}
                >
                  <Icon className="h-5 w-5 shrink-0 text-[#D4AF37]" aria-hidden />
                  <span className="flex flex-1 flex-col gap-0.5">
                    <span className="t-h3">{item.title}</span>
                    <span className="t-body">{item.body}</span>
                    <span className="t-caption">{dateTime(item.created_at)}</span>
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
